(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumiere-conversion"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-lc-slider]').forEach(slider=>{const track=slider.querySelector('[data-lc-track]'),cards=[...track.children],dots=slider.querySelector('[data-lc-dots]');cards.forEach((_,i)=>{const b=document.createElement('button');b.className='lc-dot';b.type='button';b.setAttribute('aria-label','Show review '+(i+1));b.onclick=()=>cards[i].scrollIntoView({behavior:'smooth',inline:'start',block:'nearest'});dots.append(b)});const update=()=>{const i=Math.round(track.scrollLeft/(cards[0].offsetWidth+24));[...dots.children].forEach((d,n)=>d.setAttribute('aria-current',n===i?'true':'false'))};track.addEventListener('scroll',update,{passive:true});update();slider.querySelector('[data-lc-prev]').onclick=()=>track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'});slider.querySelector('[data-lc-next]').onclick=()=>track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'})});const popup=document.querySelector('[data-lc-popup]');if(!popup)return;const old=Number(localStorage.getItem('lcWelcomeSeen'));if(old&&Date.now()-old<604800000)return;let shown=false;const show=()=>{if(shown)return;shown=true;popup.hidden=false;document.body.style.overflow='hidden';popup.querySelector('input')?.focus()};const close=()=>{popup.hidden=true;document.body.style.overflow='';localStorage.setItem('lcWelcomeSeen',String(Date.now()))};setTimeout(show,8000);addEventListener('scroll',()=>{if(scrollY>document.documentElement.scrollHeight*.35)show()},{passive:true,once:true});popup.querySelectorAll('[data-lc-close]').forEach(b=>b.onclick=close);addEventListener('keydown',e=>{if(e.key==='Escape'&&!popup.hidden)close()})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
